import Inspector from './inspector';
const { RichText } = wp.blockEditor;

export default ({ attributes, setAttributes }) => {
  const {
    text,
    variant,
    size,
    image,
    iconPosition,
    hideOnMobile,
    align,
    margin,
  } = attributes;
  let staticDefaultImage = 'https://via.placeholder.com/15x15';

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <a
        className={`
          Button wp-editor
          ${variant} ${size}
          ${hideOnMobile && 'hide-mobile'}
          ${variant == 'withIcon' && iconPosition}
          ${margin} ${align}
        `}
      >
        <RichText
          tagName="span"
          value={text}
          placeholder="Texto botão"
          keepPlaceholderOnFocus
          onChange={(text) => setAttributes({ text })}
        />

        {variant == 'withIcon' && (
          <figure>
            <img src={image.src || staticDefaultImage} />
          </figure>
        )}
      </a>
    </>
  );
};
